import React from "react";

import {
  DisplayDiv,
  DisplayTextDiv,
  LucideIconWrapper,
  MenuLink,
} from "app/NavBar/index.style";

function NavLinkItem({ item, isActive }) {
  const LucideIcon = item.lucideIcon;

  return (
    <li>
      <DisplayDiv>
        <DisplayTextDiv $bottom={item.bottomOffset ?? 0}>
          {LucideIcon && (
            <LucideIconWrapper $active={isActive}>
              <LucideIcon size={24} strokeWidth={2.1} />
            </LucideIconWrapper>
          )}
          <MenuLink to={item.to} $active={isActive}>
            {item.label}
          </MenuLink>
        </DisplayTextDiv>
      </DisplayDiv>
    </li>
  );
}

export default NavLinkItem;
